import { FC, useContext } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { v4 as uuid } from 'uuid'
import { Button } from '@microservices/wiskey-react-components'
import { Add } from '@mui/icons-material'
import { Grid } from '@mui/material'

import { WindowsCreateOrEditContext } from '@pages/WindowsCreateOrEdit'
import { getEmptySection } from '@pages/WindowsCreateOrEdit/components/helpers/getDefaultValuesWindow'
import { Section } from '@pages/WindowsCreateOrEdit/components/Section/Section'
import { ArraySectionsType } from '@pages/WindowsCreateOrEdit/types'

type SectionsProps = unknown

export const Sections: FC<SectionsProps> = () => {
  const { t } = useTranslation()
  const { control, watch, setValue, getValues } = useFormContext<ArraySectionsType>()
  const configsName = 'configs'
  const watchedConfigs = watch(configsName)

  const { isLoadingWindowById } = useContext(WindowsCreateOrEditContext)

  const {
    fields: sections,
    append,
    remove,
  } = useFieldArray({
    control,
    name: 'sections',
  })

  const handleAddSection = () => {
    const emptyValue = { ...getEmptySection(), uuid: uuid() }
    append(emptyValue)
  }

  const showButtonAddSection: boolean = sections.length === 4

  const handleRemoveSection = (index: number, sectionId: number) => {
    const currentSelectedSectionFilterFor = getValues('filterSection')

    if (sectionId && watchedConfigs.length) {
      setValue(
        configsName,
        watchedConfigs.filter(config => config.sectionId !== sectionId)
      )
    }

    if (currentSelectedSectionFilterFor?.id === sectionId) {
      setValue('filterSection', null)
    }

    remove(index)
  }

  return (
    <>
      {!isLoadingWindowById &&
        sections.map((field, index) => (
          <Section key={field.id} index={index} removeSection={handleRemoveSection} />
        ))}
      <Grid container justifyContent={'flex-end'} pb={1} width={'100%'}>
        {!showButtonAddSection && (
          <Button onClick={handleAddSection}>
            <Add fontSize='small' />
            {t('window.buttons.addSection')}
          </Button>
        )}
      </Grid>
    </>
  )
}
